import {connect} from 'react-redux';
import ReactModal from 'react-modal';
import React, {Component} from 'react';

import ObjectsAPI from '../../api/Objects';
import {createOrder} from '../../actions/Orders';
import * as OrderConst from '../../constants/Order';

const defaultProps = {
    btnTitle: '',
    className: '',
    createOrder: ordersCreateCommand => {
    },
};

class CallbackBanner extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isShowModal: false
        }
    }

    handleHideModal(event) {
        event.preventDefault();

        this.setState({
            isShowModal: false
        })
    }

    handleCallbackClick(event) {
        event.preventDefault();

        ObjectsAPI.callbackRequest(this.props.objectId, this.phoneNumber.value);

        const {firstName, lastName, code} = this.props;
        const ordersCreateCommand = {
            serviceType: OrderConst.SERVICE_TYPE.CALLBACK,
            userName: `${firstName} ${lastName}`,
            contactData: this.phoneNumber.value,
            languageName: code
        };
        this.props.createOrder(ordersCreateCommand);

        this.phoneNumber.value = '';
        this.setState({
            isShowModal: true
        });
    }

    render() {
        const i18n = this.props.i18n;
        return (
            <form className={this.props.className ? "callback-banner " + this.props.className : "callback-banner"}>
                <div className="callback-phone">
                    <i />
                    <span>{this.props.callbackNumber}</span>
                </div>
                <div className="callback-title">
                    {i18n['objectPage.callback1']}<br />{i18n['objectPage.callback2']}<br />{i18n['objectPage.callback3']}
                </div>
                <input
                    type="text"
                    className="text-field"
                    ref={ref => {
                        this.phoneNumber = ref
                    }}
                    placeholder={i18n['objectPage.enterYourNumber']}
                />
                <button onClick={::this.handleCallbackClick} className="btn">{this.props.btnTitle}</button>

                <ReactModal
                    className="custom-react-modal"
                    isOpen={this.state.isShowModal}
                    overlayClassName="custom-react-modal-overlay"
                >
                    {i18n['objectPage.callbackConfirmMessage']}
                    <br /><br />
                    <button onClick={::this.handleHideModal} className="btn">
                        {i18n['objectPage.callbackClose']}
                    </button>
                </ReactModal>
            </form>
        )
    }
}

CallbackBanner.defaultProps = defaultProps;

const mapStateToProps = state => ({
    i18n: state.languages.i18n,
    lastName: state.user.currentUser.lastName,
    code: state.languages.currentLanguage.code,
    objectId: state.objectPage.currentObject.id,
    firstName: state.user.currentUser.firstName,
    callbackNumber: state.configuration.main.callbackNumber
});

const mapDispatchToProps = {
    createOrder
};

export default connect(mapStateToProps, mapDispatchToProps)(CallbackBanner);


// WEBPACK FOOTER //
// ./src/components/PropertyPage/CallbackBanner.js